import { createSlice } from "@reduxjs/toolkit";
import { nonprofitDonationAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const nonprofitDonationSlice = createSlice({
  name: "nonprofitDonation",
  initialState: data,
  reducers: {
    nonprofitDonationSlice(state) {
      state.isLoading = true;
    },
    nonprofitDonationSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    nonprofitDonationSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    nonprofitDonationSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const nonprofitDonationHandler = (org_id:string,body={type:6}) => async (dispatch: any) => {
  try {
    dispatch(nonprofitDonationAction.nonprofitDonationSlice());
    const response: any = await nonprofitDonationAPI(org_id,body);
    dispatch(nonprofitDonationAction.nonprofitDonationSliceSuccess(response));
  } catch (e: any) {
    dispatch(nonprofitDonationAction.nonprofitDonationSliceFailure(e?.response?.data?.message));
    dispatch(nonprofitDonationAction.nonprofitDonationSliceReset());
  }
};
export default nonprofitDonationSlice.reducer;
export const nonprofitDonationAction = nonprofitDonationSlice.actions;
